export function extrairCorpoReceita(textoOriginal = '') {
  const matchCabecalho = textoOriginal.match(
    /(?:^|\n)[ \t]*USO[ \t]+(?:ORAL|EXTERNO|SUBCUT[ÂA]NEO)(?:[ \t]+CONT[ÍI]NUO)?[ \t]*:?[ \t]*(?:\r?\n)?/i
  );

  const idxInicioCorpo = matchCabecalho ? matchCabecalho.index + matchCabecalho[0].length : 0;

  // Remove apenas linhas em branco no inicio para preservar a primeira medicação.
  return textoOriginal.slice(idxInicioCorpo).replace(/^(?:[ \t]*\r?\n)+/, '');
}
